import { render } from "./zhongjinews.vue?vue&type=template&id=0e44642c&scoped=true"
import script from "./zhongjinews.vue?vue&type=script&lang=js"
export * from "./zhongjinews.vue?vue&type=script&lang=js"

import "./zhongjinews.vue?vue&type=style&index=0&id=0e44642c&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e44642c"]])

export default __exports__